import { create } from 'zustand';
import { ROUTES } from '../shared/constants/routes';

type ActiveTabStore = {
  activetab: ROUTES.READ | ROUTES.LISTEN | ROUTES.WATCH;
  setActiveTab: (isloading: ROUTES.READ | ROUTES.LISTEN | ROUTES.WATCH) => void;
  lastVideoIndex: number;
  setLastVideoIndex: (index: number) => void;
};

export const useActiveTabStore = create<ActiveTabStore>((set) => ({
  activetab: ROUTES.READ,
  setActiveTab: (activetab: ROUTES.READ | ROUTES.LISTEN | ROUTES.WATCH) => set({ activetab: activetab }),
  lastVideoIndex: 0,
  setLastVideoIndex: (index) => set({ lastVideoIndex: index }),
}));
